import { CarrierAccount } from "@redotech/redo-model/carrier-account/carrier-account";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteCarrierAccount = {
  name: "deleteCarrierAccount" as const,
  input: z.object({ teamId: zExt.objectId(), carrierAccount: CarrierAccount }),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
  }),
};
